import { queryApi } from "src/utils/api/ApiMethods"

export const queryMarinaAutocomplete = async (query) => {
  return queryApi(
    `${process.env.API_BASE_URL}/api/1.0/marina_autocomplete?query=${query}&limit=15`
  )
}
